import React from 'react';

import SleepIcon from '@mui/icons-material/Hotel';
import {
  Button,
} from '@mui/material';

import AddSleep from '../../../HealthRecord/HealthRecordCategory/Sleep/AddSleep';

import type { ChildJson } from '@/types/domain/child/entities/childEntity';
import type { FacilityJson } from '@/types/domain/childApply/entities/facilityEntity';
import type { UserType } from '@/types/domain/user/redux';

/** 入力 */
export type LineButtonsInput = {
  /** 日付 */
  date: Date,
  /** ユーザー */
  user: UserType,
  /** 子ども */
  child: ChildJson,
  /** 施設リスト */
  facilityList: FacilityJson[],
  /** 昨日で登録 */
  isYesterday: boolean,
};

const SleepButton: React.FC<LineButtonsInput> = ({
  date,
  user,
  child,
  facilityList,
  isYesterday,
}) => {
  const [isOpen, setIsOpen] = React.useState<boolean>(false);
  return (
    <>
      <Button
        variant="outlined"
        color="primary"
        startIcon={<SleepIcon />}
        style={{ marginLeft: 'auto', marginRight: '3px' }}
        onClick={() => setIsOpen(true)}
      >
        就寝
      </Button>
      {isOpen && (
        <AddSleep
          isOpen={isOpen}
          close={() => setIsOpen(false)}
          child={child}
          user={user}
          date={date}
          facilityList={facilityList}
          isYesterday={isYesterday}
        />
      )}
    </>
  );
};

export default SleepButton;
